module.exports = __webpack_public_path__ + "img/workflow_6.e514a900.jpg";